import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import DatePicker from "react-datepicker"; // New Import
import "react-datepicker/dist/react-datepicker.css"; // Basic styles
import moment from "moment";
import useDebounce from "../../../../hooks/useDebounce";

const FilterComponent = ({
    activeTab,
    onTabChange,
    sortBy,
    onSortChange,
    onDateChange,
    showTabs = true,
}) => {
    // State for Date Range [startDate, endDate]
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;

    const debouncedRange = useDebounce(dateRange, 500);

    const handleDateChange = (update) => {
        setDateRange(update);

        const [start, end] = update;

        // Only apply filter when both selected or cleared
        if ((start && end) || (!start && !end)) {
            onDateChange(update);
        }
    };


    return (
        <div className={`flex flex-col gap-4 sm:flex-row ${showTabs ? "sm:justify-between" : "sm:justify-end"} sm:items-center mb-4`}>
            {/* Tabs Section Remains Same */}
            {showTabs && (

                <div className="flex bg-[#F6F6F6] rounded-sm">

                    <button

                        className={`px-2 py-2 text-xs font-normal ${activeTab === "all" ? "bg-white shadow" : "bg-transparent"

                            }`}

                        onClick={() => onTabChange("all")}

                    >

                        View All

                    </button>

                    <button

                        className={`px-2 py-2 text-xs font-normal ${activeTab === "unshared" ? "bg-white shadow" : "bg-transparent"

                            }`}

                        onClick={() => onTabChange("unshared")}

                    >

                        Your Files

                    </button>

                    <button

                        className={`px-2 py-2 text-xs font-normal ${activeTab === "shared" ? "bg-white shadow" : "bg-transparent"

                            }`}

                        onClick={() => onTabChange("shared")}

                    >

                        Shared Files

                    </button>

                </div>

            )}

            <div className="flex flex-col sm:flex-row sm:gap-1 sm:items-center sm:space-x-4">
                <Dropdown onSelect={(key) => onSortChange(key)}>
                    <Dropdown.Toggle variant="light" id="dropdown-basic" className="!px-2 !py-2 !bg-[#F6F6F6] !rounded-sm !text-xs !font-normal border-none">
                        Sort By: {sortBy === "newest" ? "Newest First" : sortBy === "oldest" ? "Oldest First" : "Name (A-Z)"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item eventKey="newest">Newest First</Dropdown.Item>
                        <Dropdown.Item eventKey="oldest">Oldest First</Dropdown.Item>
                        <Dropdown.Item eventKey="name">Name (A-Z)</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>

                {/* New Range Date Picker */}
                {/* Updated Range Date Picker Wrapper */}
                {/* <div className="relative border border-dashed border-[#2563eb] rounded-sm bg-white px-2 py-1 flex items-center">
                    <span className="mr-1 text-gray-500">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                    </span>
                    <DatePicker
                        selectsRange
                        startDate={startDate}
                        endDate={endDate}
                        onChange={handleDateChange}
                        isClearable
                        maxDate={new Date()}
                        placeholderText="Select Date Range"
                        className="text-xs font-normal border-none outline-none focus:ring-0 focus:outline-none cursor-pointer w-[160px] bg-transparent"
                        dateFormat="dd MMM, yyyy"
                    />

                </div> */}
            </div>
        </div>
    );
};

export default FilterComponent;


export const buildQueryParams = (filters, activeTab) => {
    const params = {};

    if (filters.sortBy && filters.sortBy !== "newest") {
        params.sort = filters.sortBy;
    }

    if (Array.isArray(filters.date)) {
        const [start, end] = filters.date;

        if (start && moment(start).isValid()) {
            params.created_from = moment(start).format("YYYY-MM-DD");
        }

        if (end && moment(end).isValid()) {
            params.created_to = moment(end).format("YYYY-MM-DD");
        }
    }

    if (activeTab === "files") {
        if (filters.type === "unshared") params.your_files = true;
        if (filters.type === "shared") params.shared_files = true;
    }

    return params;
};

